/* esm.sh - mainnet-js@4.0.0-next.4/dist/module/util/delay */
function n(e){return new Promise(t=>setTimeout(t,e))}export{n as delay};
//# sourceMappingURL=delay.mjs.map